module.exports = __webpack_public_path__ + "img/Operational Light Icon.2dbd5ebb.png";